module.exports = __webpack_public_path__ + "static/media/final.adf4e567.png";